import { Resources } from 'constants/resources';

import { OrderAdjustmentsList } from 'pages/OrderAdjustments/OrderAdjustmentsList';
import { ResourceProps } from 'react-admin';

export const orderAdjustmentsResource: ResourceProps = {
  name: Resources.OrderAdjustments,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: OrderAdjustmentsList,
};
